"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    quark: "2px",
    nano: "4px",
    xxxsmall: "8px",
    xxsmall: "10px",
    xsmall: "12px",
    small: "14px",
    medium: "16px",
    large: "24px",
    xlarge: "32px",
    xxlarge: "40px"
};
// Path: src/tokens/spacing/stack.ts
//# sourceMappingURL=inset.js.map